export default __webpack_public_path__ + "static/media/vecotor_top_mobile.581426e4.svg";